/*
    This contains the configuration store for the clients app-specific settings. Like vast and fallback images, etc.
*/

import { create } from "zustand";
import { combine } from "zustand/middleware";

type State = {
    allowVAST: boolean;
    thumbMissingUrl: string;
};

type SetState = {
    setConfig: (config: State) => void;
    setAllowVAST: (allowVAST: boolean) => void;
    setThumbMissingUrl: (url: string) => void;
};

export const useConfigStore = create(
    combine<State, SetState>(
        {
            allowVAST: false,
            thumbMissingUrl: 'https://placehold.co/1920x1080/000000/ffffff.jpg'
        },
        (set) => ({
            setConfig: (config) => set(config),

            setThumbMissingUrl: (thumbMissingUrl) =>
                set((state) => ({
                    ...state,
                    thumbMissingUrl,
                })),

            setAllowVAST: (allowVAST) =>
                set((state) => ({
                    ...state,
                    allowVAST,
                })),
        }),
    ),
);
